(function(){
    'use strict';

    angular.module('elogbooks.admin.sso-users', []);
})();
